import React, { useState } from "react";
import styles from "./row.module.sass";
import Checkbox from "../../../../../../Checkbox";
import Icon from "../../../../../../Icon";
//import Control from "./Control/index";
import { useParams } from "react-router-dom";
import {ReactComponent as Add} from '../../../../../../../media/images/icons/add_meta.svg'
import {ReactComponent as Remove} from '../../../../../../../media/images/icons/remove.svg'
import Items from '../../../../../../../media/images/placeholders/Items.png'
import { useEffect } from "react";
import CurrencyTooltip from '../../../../../../CustomTooltips/CurrencyTooltip'
/* Deleted Schedule, Modal, Modal Products and Actions */

const Row = ({tableFor,fullList, item, items, index, setValue, setData,categoryIndex }) => {
    
    const {appid} = useParams()
    // const [show, setShow]=useState(false);
    // function doesItemExistInContent() {
    //     const contentsrow = JSON.parse(sessionStorage.getItem('contents'));
    //     const content=contentsrow[categoryIndex];
    //     if (!Array.isArray(content)) {
    //         setShow(false);
    //       }
    //     setShow(content?.some(val => val.itemId === item.id) || setShow(false));
    // }

    const addContent = (item, index) => {
        let itemList = [...items]
        itemList[index].status = true
        let amp = fullList
        amp[categoryIndex]=itemList
        setData(amp)
        let content = JSON.parse(sessionStorage.getItem('contents'))
        let priceArr=[]
        item.inventoryItemPrices&&item.inventoryItemPrices.map((e,i)=>{
            const { id, ...B } = e;
            priceArr.push(B)
        })
        let newContent = {iconUrl : item.iconUrl, name : item.name, itemId : item.id, type : (item.isConsumable == true ? 'Consumable' : 'Durable'), quantity : null, displayId : item.itemId, priceList:priceArr}
        if (content[categoryIndex] === null || content[categoryIndex] === undefined) {
            let tmpARR=[]
            tmpARR.push(newContent)
            content[categoryIndex]={storeContent:tmpARR}
            //content[categoryIndex].storeContent=tmpARR
        } else {
            content[categoryIndex].storeContent.push(newContent)
        }
        // setValue(content)
        sessionStorage.setItem('contents', JSON.stringify(content))
        // doesItemExistInContent()
    }

    const RemoveContent = (item, id) => {
            let itemList = [...items]
            itemList[index].status = false
            itemList[index].quantity = null
            let amp = fullList
            amp[categoryIndex]=itemList
            setData(amp)
            let content = JSON.parse(sessionStorage.getItem('contents'))
            let removedReward = content[categoryIndex].storeContent
            let remainingRewards = removedReward.filter((e,i,c)=> {
                return e.itemId != id
            })
            content[categoryIndex].storeContent=remainingRewards
            // setValue(content)
            sessionStorage.setItem('contents', JSON.stringify(content))
            //doesItemExistInContent()
    }

    const onInputChange = (e,id) => {
            let itemList = [...items]
            itemList[index].quantity = parseInt(e.target.value)
            let amp = fullList
            amp[categoryIndex]=itemList
            setData(amp)
            const content = JSON.parse(sessionStorage.getItem('contents'))
            const updatedArray = content[categoryIndex].storeContent.map(item => {
                if (item.itemId === id) {
                return { ...item, quantity: parseInt(e.target.value) };
                }
                return item;
            });
            content[categoryIndex].storeContent=updatedArray
            // setValue(content)
            sessionStorage.setItem('contents', JSON.stringify(content))
    }

    // useEffect(()=>{
    //     doesItemExistInContent()
    // },[])


    useEffect(()=>{

    }, [item])

    return (
        <>
            <div className={styles.row}>
                {/* {show? */}
                {item.status !== false ?
                    <div className={styles.col}><Remove className={styles.addIcon} onClick={()=>{RemoveContent(item, item.id)}}/></div>
                    :
                    <div className={styles.col}><Add className={styles.addIcon} onClick={()=>{addContent(item, index)}}/></div>
                }
                <div className={styles.col}>
                    <div className={styles.item}>
                        <div className={styles.modalPreview}>
                            <img src={item.iconUrl != null ? item.iconUrl : Items} alt="Item" />
                        </div>
                    </div>
                </div>
                <div className={styles.col}><div className={styles.modalItemName}>{item.name}</div><div className={styles.modalItemId}>{item.itemId}</div></div>
                <div className={styles.col}>
                    {item.inventoryItemPrices && item.inventoryItemPrices.slice(0,1).map((e,i)=>{
                        if(e.priceTypes == 'virtual currency' || e.priceTypes == 'RMG' || e.priceTypes == 'real money' || e.priceTypes == 'virtual'){
                            return (
                                <>
                                    <div className={styles.prices}>
                                        <span className={e.priceTypes == 'virtual currency' ? styles.virtual : styles.real}>{e.currency.code}<span>&nbsp;</span>{e.price}</span>
                                        {(item.inventoryItemPrices && item.inventoryItemPrices.length > 1 && i === 0) ? 
                                            <CurrencyTooltip type='item' text='Currency' data={item.inventoryItemPrices}><span className={styles.count}>+ {item.inventoryItemPrices.length - 1}</span></CurrencyTooltip> 
                                        : ''}
                                    </div>
                                </>
                            )
                        }else if(e.priceTypes == 'IAP'){
                            return(
                                <>
                                    <div className={styles.prices}>
                                        <span className={styles.IAP}>{e.realWorldCurrency.code}<span>&nbsp;</span>{e.price}</span>
                                        {(item.inventoryItemPrices && item.inventoryItemPrices.length > 1 && i === 0) ? 
                                            <CurrencyTooltip type='item' text='Currency' data={item.inventoryItemPrices}><span className={styles.count}>+ {item.inventoryItemPrices.length - 1}</span></CurrencyTooltip> 
                                        : ''}
                                    </div>
                                </>
                            )
                        }
                    })} 
                </div>
                <div className={styles.col}><div className={styles.rewardsInput}><input disabled={item.status == false ? true : false} key={item.id} className={styles.quantity} type="number" onWheelCapture={e => {e.currentTarget.blur()}} value={items[index].status == false ? '' : items[index].quantity} onChange={(e)=>{onInputChange(e, item.id)}}/></div></div>
            </div>
        </>
    );
};

export default Row;
